<template>
  <div class="field">
    <label class="label">{{ label }}</label>
    <div class="control">
      <Field
        v-bind="$attrs"
        :name="name"
        :class="['textarea', { 'is-danger': error }]"
        as="textarea"
      />
      <p v-if="error" class="help is-danger">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import { Field } from 'vee-validate';
import { startCase } from 'lodash-es';

export default {
  components: {
    Field,
  },

  inheritAttrs: false,

  props: {
    name: {
      type: String,
      required: true,
    },

    error: {
      type: String,
      default: undefined,
    },
  },

  computed: {
    label() {
      return startCase(this.name);
    },
  },
};
</script>
